<!-- Custom Smart App Banner: all browsers except Safari -->
@if (showBanner && !isSafari) {
<div
  class="smart-app-banner"
  role="region"
  [attr.aria-label]="'SMART-BANNER-LABEL' | globalTranslate"
  aria-live="polite"
>
  <div class="app-icon">
    <img
      src="assets/images/tn-logo.png"
      [attr.alt]="'SMART-BANNER-ICON-ALT' | globalTranslate"
      class="app-icon-image"
    />
  </div>
  <div class="app-info">
    <span class="app-name">{{
      "SMART-BANNER-APP-NAME" | globalTranslate
    }}</span>
    <span class="app-publisher">{{
      "SMART-BANNER-PUBLISHER" | globalTranslate
    }}</span>
  </div>
  <!-- On iOS Chrome, open deep link in new tab so iOS can intercept the Universal Link, then auto-close the tab -->
  <button
    class="get-button"
    (click)="openDeepLink()"
    type="button"
    [attr.aria-label]="
      ('SMART-BANNER-OPEN' | globalTranslate) +
      ' ' +
      ('SMART-BANNER-APP-NAME' | globalTranslate)
    "
  >
    <span>{{ "SMART-BANNER-OPEN" | globalTranslate }}</span>
  </button>
  <button
    class="x-close-button"
    (click)="dismissBanner()"
    [attr.aria-label]="'SMART-BANNER-CLOSE' | globalTranslate"
    type="button"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
}